import { useAiChatActions } from '@euler/app/flows/ai-suite/chat/AiChatActions';
import {
  BiAddAnswer,
  BiAddTarget,
  BiAnswerAction,
  biAnswerText,
} from '@euler/model/bi/answer';
import { useCallback, useEffect, useState } from 'react';
import { filter } from 'rxjs';

/**
 * Adding drafts to a dashboard by a tap: sent as `biAnswer` on the next
 * turn, and pending until that turn's reply ends.
 */
export function useBiAddTap(draftIds: string[]) {
  const chat = useAiChatActions();
  const [pending, setPending] = useState(false);
  const key = draftIds.join(',');
  const { tapSettled$, send } = chat;
  useEffect(() => {
    const subscription = tapSettled$
      .pipe(
        filter(
          tap =>
            tap.kind === 'bi' &&
            tap.answer.action === BiAnswerAction.Add &&
            tap.answer.draftIds.join(',') === key,
        ),
      )
      .subscribe(() => setPending(false));
    return () => subscription.unsubscribe();
  }, [tapSettled$, key]);
  const add = useCallback(
    (target?: BiAddTarget, dashboardName?: string): boolean => {
      const answer: BiAddAnswer = {
        action: BiAnswerAction.Add,
        draftIds: key.split(','),
        ...(target ? { target } : {}),
      };
      if (!send(biAnswerText(answer, dashboardName), { biAnswer: answer }))
        return false;
      setPending(true);
      return true;
    },
    [send, key],
  );
  return { pending, busy: chat.busy, add };
}
